export function hitungMasaKerja(tanggalMasuk) {
  if (!tanggalMasuk) return "-";
  const start = new Date(tanggalMasuk);
  if (isNaN(start)) return "-";
  const now = new Date();
  let months = (now.getFullYear() - start.getFullYear()) * 12 + (now.getMonth() - start.getMonth());
  if (now.getDate() < start.getDate()) months--;
  if (months < 0) return "-";
  const years = Math.floor(months / 12);
  const rem = months % 12;
  if (years === 0 && rem === 0) return "< 1 bln";
  if (years === 0) return `${rem} bln`;
  if (rem === 0) return `${years} thn`;
  return `${years} thn ${rem} bln`;
}

const pad2 = (n) => String(n).padStart(2, "0");

export function formatTanggal(d) {
  if (!d) return "-";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d));
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  const date = new Date(d);
  if (isNaN(date)) return d;
  return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)}/${date.getFullYear()}`;
}

export function formatWaktu(iso) {
  if (!iso) return "-";
  const date = new Date(iso);
  if (isNaN(date)) return iso;
  return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)}/${date.getFullYear()} `
    + `${pad2(date.getHours())}.${pad2(date.getMinutes())}`;
}

export function hitungUsia(tanggalLahir) {
  if (!tanggalLahir) return null;
  const d = new Date(tanggalLahir);
  if (isNaN(d)) return null;
  const now = new Date();
  let age = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age--;
  return age >= 0 ? age : null;
}

const TONE_CLASSES = {
  rose: "bg-rose-50 text-rose-700 border-rose-200",
  amber: "bg-amber-50 text-amber-700 border-amber-200",
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export function statusKontrak(worker, usiaPensiun) {
  const usia = hitungUsia(worker.tanggal_lahir) ?? (worker.usia != null && worker.usia !== "" ? Number(worker.usia) : null);
  if (usiaPensiun && usia != null && usia >= usiaPensiun) {
    return { label: `Pensiun (${usia} thn)`, className: TONE_CLASSES.rose };
  }
  const tak = (worker.tanggal_akhir_kontrak || "").trim();
  if (!tak) return null;
  const end = new Date(tak);
  if (isNaN(end)) return null;
  const now = new Date();
  const days = Math.floor((new Date(end.getFullYear(), end.getMonth(), end.getDate()) -
    new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
  if (days < 0) return { label: `Lewat ${-days} hr`, className: TONE_CLASSES.rose };
  if (days === 0) return { label: "Berakhir hari ini", className: TONE_CLASSES.rose };
  if (days <= 30) return { label: `${days} hr lagi`, className: TONE_CLASSES.amber };
  return {
    label: `s/d ${pad2(end.getDate())}/${pad2(end.getMonth() + 1)}/${end.getFullYear()}`,
    className: TONE_CLASSES.green,
  };
}
